import { ThemeProvider, Box, Flex, get } from "theme-ui";
import { Global } from "@emotion/react";
import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Modal from "react-modal";
import { AnimatePresence } from "framer-motion";
import { Provider } from "react-redux";

import { theme } from "./styles";
import { Home, Answers, Contact, Terms } from "./views";
import { LanguageSelector, Navbar } from "./components";
import { ROUTES } from "./constants";
import { Footer } from "./components/molecules/Footer/Footer";
import { store } from "./redux/store";

Modal.setAppElement("#root");
pendo.initialize();

const MainNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Flex
      sx={{
        flexDirection: "column",
        alignItems: "stretch",
        minHeight: "100vh",
      }}
    >
      <Navbar onNavClick={navigate} activeRoute={location.pathname} />
      <Box as="main" sx={{ flexGrow: 1 }}>
        <AnimatePresence exitBeforeEnter>
          <Routes location={location} key={location.key}>
            <Route path="/" element={<Home />} />
            <Route path={ROUTES.answers} element={<Answers />} />
            <Route path={ROUTES.terms} element={<Terms />} />
            <Route path={ROUTES.contact} element={<Contact />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </AnimatePresence>
      </Box>
      <Footer />
    </Flex>
  );
};

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <Global
          styles={(theme) => ({
            "*": { fontFamily: get(theme, "fonts.body") },
          })}
        />
        <BrowserRouter>
          <MainNavigation />
        </BrowserRouter>
        <Box sx={{ position: "fixed", right: [4, 7], bottom: 0, zIndex: 1 }}>
          <LanguageSelector />
        </Box>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
